/* eslint-disable import/prefer-default-export */
import { createMutation } from 'react-query-kit';
import { AxiosError } from 'axios';
import { axios } from '..';

type Variables = {
  id: string;
  payload: {
    grade: string;
    teacher: string;
  };
};
export const useAddGrade = createMutation<any, Variables, AxiosError>({
  mutationFn: async (variables) =>
    axios
      .post(`/School/grades/new_grade/${variables.id}`, variables.payload)
      .then((response) => response.data)
});
